import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mwo-list-counter',
  templateUrl: './list-counter.component.html',
  styleUrls: ['./list-counter.component.scss']
})
export class ListCounterComponent implements OnInit {
  @Input() count = 0;
  @Input() message: string;

  @Input() modeInline = false;
  constructor() { }

  ngOnInit() {
  }
}
